import React from 'react'

export const LogicOption = ({ store, onClick, scope }) => (
    <div className="ff-mode-options">
        {store.logicOptions(scope).map(({ label, hint, value }) => (
            <div
                className={`ff-mode-option ${store.flag.data[scope].logic === value ? 'is-selected' : ''}`}
                onClick={() => onClick(value)}
            >
                <div className="ff-mode-option__label">{label}</div>
                <div className="ff-mode-option__hint">{hint}</div>
            </div>
        ))}
    </div>
)
